import { CenteredLayout } from "../atoms/Layouts"
import { HR, Spacer } from "../atoms/Atoms"
import { AccordionWithoutMarkdown } from "../Accordion"
import React from "react"
import L10n from "../../../lib/carrot-l10n"
import { Body, BodySmall } from "../atoms/Bodies"
import { TextLink } from "../atoms/links/TextLink"
import { Modal } from "../modal/Modal"
import { H2Library } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const WhyWereAskingModal = ({ onExit, expandIsInfertility = false, expandIsMedicalNecessity = false }) => (
  <Modal titleText={l`client.reimbursements.whyWeAreAsking`} onExit={onExit}>
    <CenteredLayout>
      <div className={"mw6"}>
        <H2Library variant="dark">{l`Why are you asking these questions?`}</H2Library>
        <Spacer height={1} />
        <Body className={"black-80"}>
          {l`Some care and services may be subject to taxes. Asking these questions allows us to determine when that's the case so we can process your reimbursement.`}
        </Body>
        <Spacer height={1} />
        <HR color={"black-10"} />
        <Spacer height={1} />
        <InfertilityDiagnosisAccordion shouldExpand={expandIsInfertility} />
        <HR color={"black-10"} />
        <Spacer height={1} />
        <MedicalNecessityAccordion shouldExpand={expandIsMedicalNecessity} />
        <Spacer height={2} />
      </div>
    </CenteredLayout>
  </Modal>
)

const InfertilityDiagnosisAccordion = ({ shouldExpand }) => (
  <AccordionWithoutMarkdown
    shouldExpand={shouldExpand}
    title={l`If fertility care was received, was the care related to an infertility diagnosis issued by your doctor?`}
  >
    <div style={{ paddingLeft: "20px" }}>
      <Spacer height={1} />
      <Body color={"black-80"}>{l`Fertility care may be taxable under your Carrot benefit.`}</Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`Infertility is generally diagnosed by a doctor when a cisgender heterosexual couple is unable to get pregnant after a year of unprotected intercourse. This definition may vary by state or country, and the time frame may vary by the couple's age.`}
      </Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`People with ovaries might also receive an infertility diagnosis if they are unable to get pregnant after a certain number of donor insemination cycles.`}
      </Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`If you’re unsure or need help answering this question, ask your fertility doctor or talk to our `}{" "}
        <TextLink href={"/talk-to-carrot"}>Care Team</TextLink>.
      </Body>
      <Spacer height={1} />
      <BodySmall color={"black-60"}>
        {l`This is not tax advice. You should always consult a tax professional for formal guidance on filing and paying taxes.`}
      </BodySmall>
    </div>
  </AccordionWithoutMarkdown>
)

const MedicalNecessityAccordion = ({ shouldExpand }) => (
  <AccordionWithoutMarkdown
    shouldExpand={shouldExpand}
    title={l`If preservation care was received, was the care considered medically necessary by your doctor?`}
  >
    <div style={{ paddingLeft: "20px" }}>
      <Spacer height={1} />
      <Body color={"black-80"}>{l`Preservation care may be taxable under your Carrot benefit.`}</Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`Your fertility doctor may consider preservation care medically necessary if you’re receiving other care that could impact your reproductive health.`}
      </Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`For example, you may be advised by your doctor to cryopreserve eggs, semen, or embryos if you need medical treatment such as chemotherapy or radiation, or surgery involving your kidney, bladder, urethra, or ovaries.`}
      </Body>
      <Spacer height={1} />
      <Body color={"black-80"}>
        {l`If you’re unsure whether your preservation care is considered medically necessary or have more questions, ask your fertility doctor or talk to our `}{" "}
        <TextLink href={"/talk-to-carrot"}>Care Team</TextLink>.
      </Body>
      <Spacer height={1} />
      <BodySmall color={"black-60"}>
        {l`This is not tax advice. You should always consult a tax professional for formal guidance on filing and paying taxes.`}
      </BodySmall>
    </div>
  </AccordionWithoutMarkdown>
)

export { WhyWereAskingModal }
